// @flow
import { COUNTRY_POI } from 'Client/cms/toolkit/constants';
import { CountryPoiLine } from 'Components/lines/country-poi-line/CountryPoiLine';
import { countryPoiResolver } from './countryPoi.resolver';

export const countryPoiDescriptor = {
  name: COUNTRY_POI,
  component: CountryPoiLine,
  resolve: countryPoiResolver.resolve,
};
